import { MenuItem, TextField } from '@material-ui/core';
import React from 'react';

import { IPublisher } from '~/src/dash/api/console-api';
import { DEAL_SSP_LIST } from '~/src/dash/api/deals';
import {
  getHeaderBidderAdaptersForPublisher,
  IHeaderBidderAdapter,
} from '~/src/dash/utils/header-bidder-adapters';

interface IPartnerSelectProps {
  name: string;
  onChange: (bidderTypeKey: React.ChangeEvent) => void;
  value: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  publisher: IPublisher;
}

export const DealBidderTypeSelect = ({
  onChange,
  value,
  name,
  fullWidth,
  error,
  helperText,
  disabled,
  publisher,
}: IPartnerSelectProps) => {
  const availablePartners = getHeaderBidderAdaptersForPublisher('', false, publisher).filter(
    (headerBidderAdapters) => DEAL_SSP_LIST.includes(headerBidderAdapters.key),
  );
  return (
    <TextField
      name={name}
      select
      fullWidth={fullWidth}
      required
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      disabled={!!disabled}
    >
      <MenuItem value=''>None</MenuItem>
      {availablePartners.map((hb: IHeaderBidderAdapter) => {
        return (
          <MenuItem key={'hb_' + hb.key} value={hb.key}>
            {hb.text}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
